import React from 'react';
import left_part from '../../images/fill_profile.svg';

export default function FillProfileImage({firstName} : {firstName: string}) {
    return (
        <div style={{height: '100%', width: '100%'}}>
            <p className="welcome-caption">
                {firstName ? (firstName + ', добро пожаловать в РТСИМ.Карьера!') : 'Добро пожаловать в РТСИМ.Карьера!'}
            </p>
            <img src={left_part} className="auth-sidebar-content" alt='' />
            <div className="different-edges-container" style={{marginTop:'-52px'}}>
                <div className="left-edge auth-nav" style={{marginTop:'-30px'}}>
                    <p> Что такое&nbsp;  </p>
                    <a href="http://rtsimskills.tilda.ws/" className="gray-link" target="_blank" rel='noreferrer'> РТСИМ.КАРЬЕРА? </a>
                </div>
                <div className="right-edge picture-by" style={{marginRight:'32px'}}>
                    Image by&nbsp; <a href="https://www.freepik.com/free-vector/team-engineers-workers-controlling-oil-gas-pipeline_20827465.htm#query=engeneer%20oil&position=2&from_view=search&track=ais"> pch.vector</a> &nbsp;on Freepik
                </div>
            </div>
        </div>
    )
}